function openSpec() {
    document.getElementById("mySpec").style.height = "100%";
  	//$("html, body").animate({ scrollTop: "0px" });
  	$("body").addClass("mySpec_open");
}
function openSpec2() {
    document.getElementById("mySpec2").style.height = "100%";
  	//$("html, body").animate({ scrollTop: "0px" });
  	$("body").addClass("mySpec_open");
}

/* Close */
function closeSpec() {
    if ($("#mySpec").length > 0) {
      document.getElementById("mySpec").style.height = "0%";
    }
    if ($("#mySpec2").length > 0) {
      document.getElementById("mySpec2").style.height = "0%";
    }
    
  	$("body").removeClass("mySpec_open");
    $(".airconoverlay").css("height", "0");
    console.log('close tech specs');
}


function toggleSpec(){
  
  if(document.getElementById("mySpec").style.height == "100%"){
  	closeSpec();
  }
  else{
  	openSpec();
  }
}
function toggleSpec2(){
  
  if(document.getElementById("mySpec2").style.height == "100%"){
  	closeSpec();
  }
  else{
  	openSpec2();
  }
}
function toggleMtSpec(){
  if(document.getElementsByClassName("airconoverlay")[0].style.height == "100%"){
  	document.getElementsByClassName("")[0].style.height = "0%";
  	$("body").removeClass("mySpec_open");
    
  }
  else{
  	document.getElementsByClassName("airconoverlay")[0].style.height = "100%";
  	//$("html, body").animate({ scrollTop: "0px" });
  	$("body").addClass("mySpec_open");
  }
}
/* Start of VWO Tech Specs Desktop 
window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || function(timeOutFn){return setTimeout(timeOutFn, 1000 / 60);};
window['PRT_2396_V1'] = function(){
  if(typeof $ !== typeof undefined && $('#mySpec').length && !document.querySelectorAll('.PRT_2396_V1').length){
    updateChanges_PRT_2396_V1();
    document.querySelector('body').classList.add('PRT_2396_V1');
  }else if(!document.getElementsByClassName('PRT_2396_V1').length){
    window.requestAnimationFrame(PRT_2396_V1);
  }
};
window.PRT_2396_V1();        
function updateChanges_PRT_2396_V1(){
  addSpecsWrapper();
  divideSpecsIntoTwo();
  addMobileSpecClickHandler();
  setTechTopPosition();
  $(document).click(function(){
    setTimeout(function(){
      var techHeight = $('#mySpec.overlay').height();
      console.log(techHeight);
      if(techHeight > 0){
        $('body').addClass('isTechOpen');
      } else {
        $('body').removeClass('isTechOpen');
      }
    },500);
    setTechTopPosition();
  });
  $(window).resize(function(){
    setTechTopPosition();
    makeFirstSpecActive();
  });
}
function addSpecsWrapper(){
  if(!$('.vwo_specs').length){
    var prodName = $('h1.product-single_desktop_title').text();
    $('#mySpec .overlay-table > *').wrapAll('<div class="vwo_specs"></div>');
    $('.vwo_specs > p').each(function(){
      var specName = $(this).text().trim().toLowerCase().replace(/[^\w\s]/gi, '').replace(/ /g, '');
      var specBlock = '<div class="vwo_specBlock '+ specName +'"><div class="vwo_specTitle"></div><div class="specInfo"></div></div>';
      $(this).before(specBlock);
      $(this).next('table').appendTo($(this).prev('.vwo_specBlock').find('.specInfo'));
      $(this).prependTo($(this).prev('.vwo_specBlock').find('.vwo_specTitle'));
    });
    $('#mySpec > a.closebtn').prependTo('#mySpec .overlay-content .overlay-table');
    $('.vwo_specs').before('<h2>'+ prodName +'</h2>');
  }
}                                      
function divideSpecsIntoTwo(){
  if(!$('.vwo_blockWrap').length){
    $('.vwo_specs').prepend('<div class="blockWrap leftWrap"></div><div class="blockWrap rightWrap"></div>');
    $('.vwo_specs > .vwo_specBlock:not(.keyspecifications):not(.physicalcharacteristics)').appendTo('.blockWrap.rightWrap');
    $('.vwo_specs > .keyspecifications, .vwo_specs > .physicalcharacteristics').appendTo('.blockWrap.leftWrap');
    $('.blockWrap.leftWrap > .physicalcharacteristics').clone().insertBefore('.vwo_specBlock.warranty').addClass('vwo_mobileOnly');
    $('.blockWrap.rightWrap > .physicalcharacteristics.vwo_mobileOnly').hide();
  }
} 
function addMobileSpecClickHandler(){
  $('.vwo_specs .vwo_specTitle').click(function(){
    if(window.matchMedia('(max-width:767px)').matches){
      $(this).parent('.vwo_specBlock').toggleClass('active');
      $('.vwo_specBlock').not($(this).parent('.vwo_specBlock')).removeClass('active');
      if($(this).parent('.vwo_specBlock.active').length){
        $('html,body').animate({
          scrollTop:$(this).offset().top-10
        },200);
      }
    }
  });
  //making first spec active
  makeFirstSpecActive();
}
function makeFirstSpecActive(){
  if($('.vwo_specBlock.active').length == 0 && window.matchMedia('(max-width:767px)').matches){
    $('.blockWrap.leftWrap > .vwo_specBlock:first-child .vwo_specTitle').click();
  }
}
function setTechTopPosition(){
  var headerHeight = $('#shopify-section-header').height();
  $('#mySpec.overlay').css({
    top:headerHeight
  });
}

/* End of VWO Tech Specs Desktop */
